"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
var _lodash = _interopRequireDefault(require("lodash"));
var _InfoItem = _interopRequireDefault(require("@/components/Store/InfoItem.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 新增编辑 潜在门店（后续可扩展为所有）
 * 目前只有新增，后续自行扩展
 */
/** package */
/** components */
/** services */
/** mixins */
/** utils */
var _default2 = exports.default = {
  components: {
    InfoItem: _InfoItem.default
  },
  mixins: [_dialog.default, _myform.default],
  props: {
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.rtmOptions: [], // 门店RTM类型select
     * optConfig.storeCategoryOptions: [], // 客户类型select（零售店类别）
     * optConfig.storeStructureOptions: [], // 零售店性质select
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     * optConfig.daMethodOptions: [], // 记账方式select
     * optConfig.tireSupplierOptions: [], // 主要进货渠道select
     * optConfig.accountMethodOptions: [], // 结算方式select
     * optConfig.tyreBrandOptions: [], // 轮胎品牌select
     * optConfig.mainserviceOptions: [], // 主要服务项目select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var defaultForm = {
      /** 基本信息 */
      rtlRtmCategory: 'potential',
      // '潜在客户', // 零售店RTM类别
      retailerType: 'Potential',
      // 零售店类别
      retailerTypeDescription: 'Potential',
      // 零售店类别描述
      rtlSapId: '',
      // 客户编号
      rtlFullName: '',
      // 店名
      rtlAddress: '',
      // 地址
      PCD: [],
      // 省市区 不传后端
      rtlRegion: '',
      // 省label
      rtlRegionCode: '',
      // 省
      rtlCity: '',
      // 市label
      rtlCityCode: '',
      // 市
      rtlDistrict: '',
      // 区label
      rtlDistrictCode: '',
      // 区
      contactsNameOne: '',
      // 联系人1
      contactsMobileOne: '',
      // 手机1
      /** 更多信息 */
      contactsNameTwo: '',
      // 联系人2
      contactsMobileTwo: '',
      // 手机2
      contactsNameThree: '',
      // 联系人3
      contactsMobileThree: '',
      // 手机3
      remarkOne: '',
      // 分类1
      remarkTwo: '',
      // 分类2
      remarkThree: '',
      // 分类3
      /** 零售店性质和人员情况 */
      customerTireBizYear: undefined,
      // 从事轿车轮胎零售历史 (年)
      customerTireSob: undefined,
      // 轿车轮胎占总业务量
      monthTireSalesAvg: undefined,
      // 轮胎月均总销量
      storeStructure: '',
      // 零售店性质
      staff: undefined,
      // 员工数
      /** 店招信息附店招照片 */
      signBoardBrand: '',
      // 店招品牌
      otherBrand: '',
      // 其他品牌
      installationDate: '',
      // 安装日期
      dueTime: '',
      // 到期日期
      photo1: '',
      // 门头照片
      photo2: '',
      // 照片1
      photo3: '',
      // 照片2
      /** 店内主要服务项目 */
      siTire: 'N',
      // 轮胎 选中(Y / N) Validate[regexp: Y|N; ]
      siMaintainence: 'N',
      // 保养 选中(Y / N) Validate[regexp: Y|N; ]
      siFastRepair: 'N',
      // 快修 选中(Y / N) Validate[regexp: Y|N; ]
      siBeauty: 'N',
      // 美容 选中(Y / N) Validate[regexp: Y|N; ]
      siWashing: 'N',
      // 洗车 选中(Y / N) Validate[regexp: Y|N; ]
      siOther: '',
      // 其他服务
      siMain: '',
      // 主要服务项目
      siMainPercentage: undefined,
      // 主要服务占比（营业额）
      /** 店内设施设备 */
      area: undefined,
      // 店面积
      workingBay: undefined,
      // 工位数
      accountingMethod: '',
      // 记账方式
      laundry: 'N',
      // 洗手间 (Y / N) Validate[regexp: Y|N; ]
      restRoom: 'N',
      // 客户休息室 (Y / N) Validate[regexp: Y|N; ]
      alignment: 'N',
      // 四轮定位 (Y / N) Validate[regexp: Y|N; ]
      fitting: 'N',
      // 装拆胎机 (Y / N) Validate[regexp: Y|N; ]
      balancing: 'N',
      // 动平衡机 (Y / N) Validate[regexp: Y|N; ]
      lifting_machine: 'N',
      // 举升机 (Y / N) Validate[regexp: Y|N; ]
      /** form */
      tireSalesInfos: [
        // {
        //   key: 1,
        //   tireBrand: '品牌1', // 轮胎品牌
        //   tireSupplier: '', // 主要进货渠道 (DIS/SP 代理商 /Whole sales 批发商)
        //   paymentTerms: '', // 结款方式（现结/账期）
        //   monthlyAvgSales: undefined, // 月均销量
        //   stock: undefined // 库存
        // }
      ],
      tyreEighteenGreater: undefined // storeMix 比例
    };
    var phoneRule = function phoneRule(rule, value, callback) {
      if (value && (0, _validate.validPhone)(value)) {
        callback(new Error(_this.$t('errorValid.validPhone')));
      } else {
        callback();
      }
    };
    // 正整数判定
    var numberRule = function numberRule(rule, value, callback) {
      if (value && (0, _validate.isSn)(value)) {
        callback(new Error(_this.$t('errorValid.validNumber')));
      } else {
        callback();
      }
    };
    var txtRule = function txtRule(rule, value, callback) {
      // if (value && validRule1(value)) {
      //   callback(new Error(this.$t('errorValid.validText')))
      // } else {
      //   callback()
      // }
      // 门店管理和访店报告，文字的字段不加限制
      callback();
    };
    var floatRule = function floatRule(rule, value, callback) {
      if (value) {
        if ((0, _validate.isFloat)(value)) {
          callback(new Error(_this.$t('retailStoresInfo.error.float')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      dialogStatus: 'create',
      // 弹窗模式 create edit view
      /** form group */
      formLabelWidth: '120px',
      uploadParams: {
        // businessKey: retailorStoreInfoPk, // 不知道编辑要不要这个字段，后续扩展编辑的人去问问
        resourceConfigFlag: 'sfe_store'
      },
      // 上传图片配置
      form: _lodash.default.cloneDeep(defaultForm),
      initForm: _lodash.default.cloneDeep(defaultForm),
      // initForm: Object.assign({}, defaultForm),
      rules: {
        /** 只校验正确性 */
        validatePhone: [{
          trigger: ['blur'],
          validator: phoneRule
        }],
        validateNumber: [{
          trigger: ['blur'],
          validator: numberRule
        }],
        validateIpt: [{
          trigger: ['blur'],
          validator: txtRule
        }],
        validateFloat: [{
          trigger: ['blur'],
          validator: floatRule
        }],
        /** 非空校验 */
        iptEmpty: [{
          required: true,
          trigger: ['change', 'blur'],
          message: this.$t('errorValid.empty')
        }],
        phoneEmpty: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.emptyPhone')
        }],
        chooseEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }],
        uploadEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptyUpload')
        }]
      },
      /** other */
      canSubmit: true,
      info: {} // 详情 (预留字段，编辑、查看需要)
    };
  },
  computed: {
    // 编辑模式 view edit（新增和编辑都会启用编辑模式）
    mode: function mode() {
      return this.dialogStatus === 'view' ? 'view' : 'edit';
    },
    // 是否可编辑
    canEdit: function canEdit() {
      return this.mode === 'edit';
    },
    // 标题 目前只有新开卡
    dialogTitle: function dialogTitle() {
      return this.$t("doubleWeekPlan.title.addStore");
    }
  },
  watch: {
    'optConfig.tyreBrandOptions': {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        // console.log(11, this.form.tireSalesInfos)
        this.initTireSalesInfos(val);
      }
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.isShowModel = true;
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
        _this2.initTireSalesInfos(_this2.optConfig.tyreBrandOptions || []);
      });
    },
    // 初始化销售情况
    initTireSalesInfos: function initTireSalesInfos(arr) {
      var _this$form$tireSalesI, _this$initForm$tireSa;
      var newTable = (arr || []).map(function (item) {
        return {
          key: item.code,
          tireBrand: item.name,
          // 轮胎品牌
          tireSupplier: '',
          // 主要进货渠道 (DIS/SP 代理商 /Whole sales 批发商)
          paymentTerms: '',
          // 结款方式（现结/账期）
          monthlyAvgSales: undefined,
          // 月均销量
          stock: undefined // 库存
        };
      });
      (_this$form$tireSalesI = this.form.tireSalesInfos).splice.apply(_this$form$tireSalesI, [0, this.form.tireSalesInfos.length].concat((0, _toConsumableArray2.default)(newTable)));
      (_this$initForm$tireSa = this.initForm.tireSalesInfos).splice.apply(_this$initForm$tireSa, [0, this.initForm.tireSalesInfos.length].concat((0, _toConsumableArray2.default)(newTable)));
    },
    /** 销售table */tableIndex: function tableIndex(index) {
      return index + 1;
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;
      var columns = param.columns,
        data = param.data;
      var sums = []; // 声明变量
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this3.$t('salesStatus.column.salesTotal');
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (column.property === 'stock' ||
        // 需要显示和合计纵列
        column.property === 'monthlyAvgSales') {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += '';
        }
      });
      return sums;
    },
    /** 保存 */saveItem: function saveItem() {
      var _this4 = this;
      console.log('保存的数据格式', this.form);
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          _this4.$message.error(_this4.$t('errorValid.formError'));
          return;
        }
        // 重复触发
        if (!_this4.canSubmit) {
          return false;
        }
        _this4.canSubmit = false;
        var other = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(_this4.form), _this4.form));
        delete other.PCD;
        var params = (0, _objectSpread2.default)({}, other);
        (0, _doubleWeekPlan.newStore)(params).then(function () {
          _this4.$message({
            message: _this4.$t('common.saveSuccess'),
            type: 'success'
          });
          _this4.$emit('refresh');
          _this4.isShowModel = false;
        }).catch(function (err) {
          _this4.errorHandle(err, 'dataForm');
        }).finally(function () {
          _this4.canSubmit = true;
        });
      });
    }
  }
};